import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";

function SiteMap() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <>
        <>
    <Helmet>
      <title>Site Map | Taskflier </title>
      </Helmet>
     

 <div class="pricing-section-one  md-mb-80 bg-gray">
   <div class="fancy-hero-one">
      <div class="container">
         <div class="row">
            <div class="col-xl-10 col-lg-11 m-auto">
               <h2 class="font-rubik plantitle">Site map
               </h2>
               </div>
         </div>
        
      </div>
      <div class="bubble-one"></div>
      <div class="bubble-two"></div>
      <div class="bubble-three"></div>
      <div class="bubble-four"></div>
      <div class="bubble-five"></div>
      <div class="bubble-six"></div>
   </div>
   
</div>


<div class="pricing-section-one  md-mb-80 bg-white ">
   <div class="fancy-hero-one">
      <div class="container">
         <div class="row">
           

         <ul class="sitemaplinks text-left">
   <li><Link to="/about-us">About us</Link></li>
   <li><span>Solutions</span>
                      <ul class="mega-dropdown-list featuresitem">
                        <li><Link to="/solutions/enterprise">Enterprise</Link></li>
                        <li><Link to="/solutions/construction">Construction</Link></li>
                        <li><Link to="/solutions/software-development">Software Developement</Link></li>
                        <li><Link to="/solutions/education">Education</Link></li>
                        <li><Link to="/solutions/marketing">Marketing</Link></li>
                        <li><Link to="/solutions/startup">Startup</Link></li>
                        <li><Link to="/solutions/testing">Testing</Link></li>
                        <li><Link to="/solutions/real-estate">Real Estate</Link></li>
                        <li><Link to="/solutions/consulting-services">Consulting Services</Link></li>
                        <li><Link to="/solutions/law">Law</Link></li>
                        <li><Link to="/solutions/ca-management">CA Management</Link></li>
                        </ul>
                    
   </li>
   <li>
      <span>Features</span>
      <ul>
            <li><Link to="/features/theme-customizations">Theme Customizations</Link></li>
            <li><Link to="/features/task-management-software">  Task Management </Link></li>
            <li><Link to="/features/employee-management-software"> Employee Management </Link></li>
            <li><Link to="/features/client-management-software"> Client Management </Link></li>
            <li><Link to="/features/charts-reporting">Charts &amp; Reporting </Link></li>
            <li><Link to="/features/attendance-management-software">Attendance</Link></li>
            <li><Link to="/features/todo-list">Todo List</Link></li>
            <li><Link to="/features/time-tracking-software">Time Tracking</Link></li>
            <li><Link to="/features/payment-expense">Payment &amp; Expense</Link></li>
            <li><Link to="/features/team-chat">Team Chat</Link></li>
            <li><Link to="/features/appointment">Appointment</Link></li>
            <li><Link to="/features/employee-documentation">Employee Documentation</Link></li>
            <li><Link to="/features/lead-management-software">Leads Management</Link></li>
            <li><Link to="/features/mobile-access">Mobile Access</Link></li>
            <li><Link to="/features/hr-management-software">HRMS</Link></li>
         </ul>
   </li>
   <li><Link to="/customers">Customers</Link></li>
   <li><Link to="/pricing">Pricing</Link></li>
   <li><Link to="/contact-us">Contact</Link></li>
   <li><Link to="/upcomingevent">Upcoming Event <i class="bi bi-calendar-plus"></i></Link></li>
   <li><Link to="/login">Login</Link></li>
   <li><Link to="/demo/request">Request Demo</Link></li>


   <li>
      <span>Resources</span>
      <ul>
   <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/security">Security</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-service">Terms of Service  </Link>
                  </li>
                  <li>
                    <Link to="/cookie-policy">Cookie Policy</Link>
                  </li>
                  </ul>
                  </li>

</ul>
         </div>
        
      </div>
      
   </div>
   
</div>
    </>
    </>
  )
}

export default SiteMap
